// Crisp — chargement du widget chat
// L'ID de website est défini ici pour éviter tout <script> inline dans le .liquid (règle §4).
window.$crisp = [];
window.CRISP_WEBSITE_ID = '5a139f10-5d89-415f-be43-79c38ce0e485';
(function () {
  var s = document.createElement('script');
  s.src = 'https://client.crisp.chat/l.js';
  s.async = true;
  document.head.appendChild(s);
})();
